"use client";

import Link from "next/link";

export function ErrorScreen({ retry }: { retry: () => void }) {
  return (
    <main id="main-content" tabIndex={-1} className="mx-auto flex min-h-[60dvh] max-w-xl flex-col justify-center px-6 py-16 text-[#1F1B2E]">
      <h1 className="text-2xl font-bold">We couldn’t load this page</h1>
      <p className="mt-3 text-base leading-relaxed text-[#4A5468]">Try again. If the problem continues, contact us and we’ll help.</p>
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <button onClick={retry} type="button" className="rounded-full bg-[#3D69B0] px-6 py-3 font-semibold text-white">Try again</button>
        <Link href="/" className="font-semibold text-[#3D69B0]">Home</Link>
        <a href="mailto:support@b-laundry.co" className="font-semibold text-[#3D69B0]">Contact support</a>
      </div>
    </main>
  );
}
